<template>
  <div>
    <NavTop class="navbar">
    </Navtop>
    <!-- 内容 -->
    <div class=" box content">
      <div class="boox_r">
        <div class="box_r_t">
          <div class="box_r_t_l">搜索内容</div>
          <div class="box_r_t_r">
            <span @click="goHome">首页/</span>
          </div>
        </div>
        <div class="box_r_b">
          <ul>
            <li v-for="(item,index) in listData" :key="index">
              <div @click="clickList(item)">
                <span>{{ item.title }}</span>
                <span>{{ extractDate(item.publishTime) }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div style="width: 100%;display: flex;justify-content: center;   margin-bottom: 100px">
      <el-pagination v-if="total > pageSize" @current-change="clickPage" v-model="pageNum" :page-size="pageSize"
                     background
                     layout="prev, pager, next"
                     :total="total"/>
    </div>
  </div>
</template>
<script>
import home from '../../api/home.js'

export default {
  data () {
    return {
      // 页数
      pageNum: 1,
      // 每页数量
      pageSize: 15,
      // 总条数
      total: 0,
      listData: [
        {
          txt: '喜报||我校一项项目获批国家民委民族研究项目2024年度后期资助课题立项',
          time: '2024-11-15'
        },
        {
          txt: '喜报||我校一项项目获批国家民委民族研究项目2024年度后期资助课题立项',
          time: '2024-11-15'
        },
        {
          txt: '喜报||我校一项项目获批国家民委民族研究项目2024年度后期资助课题立项',
          time: '2024-11-15'
        },
        {
          txt: '喜报||我校一项项目获批国家民委民族研究项目2024年度后期资助课题立项',
          time: '2024-11-15'
        },
        {
          txt: '喜报||我校一项项目获批国家民委民族研究项目2024年度后期资助课题立项',
          time: '2024-11-15'
        },
        {
          txt: '喜报||我校一项项目获批国家民委民族研究项目2024年度后期资助课题立项',
          time: '2024-11-15'
        },
        {
          txt: '喜报||我校一项项目获批国家民委民族研究项目2024年度后期资助课题立项',
          time: '2024-11-15'
        },
      ]
    }
  },
  created () {
    if (this.$route.params.search) {
      this.search(this.$route.params.search, this.pageNum, this.pageSize)
      console.log(this.$route.params.search)
    }
  },
  mounted () {
    // this.pageNum = 1
  },
  watch: {
    // 使用字符串路径监听
    '$route.params.search': function (newVal, oldVal) {
      // 当 $route.params.val 发生变化时，这个函数会被调用
      console.log(newVal, 'lllll')
      // this.pageNum = 1
      // 在这里处理变化
      this.clickPage(newVal, this.pageNum, this.pageSize)
    }
  },
  methods: {
    // 截取日期
    extractDate (dateTimeStr) {
      if (dateTimeStr) {
        // 使用空格分割日期和时间
        const parts = dateTimeStr.split(' ')
        // 返回日期部分
        return parts[0]
      }
      return dateTimeStr
    },
    // 搜索
    async search (item, pageNum, pageSize) {
      try {
        const res = await home.search({keyWord: item, pageNum, pageSize})
        this.listData = res.rows
        this.total = res.total
        console.log(res)
      } catch (e) {
        console.error(e)
      }
    },
    // 点击列表
    clickList (item) {
      this.$router.push('/searchs/detail/1/1' + '/' + item.id)
    },
    goHome () {
      this.$router.push('/')
    },
    // 点击分页
    clickPage (e) {
      this.pageNum = e
      this.search(this.$route.params.search, this.pageNum, this.pageSize)
    }
  }
}
</script>
<style lang="less" scoped>
.box {
  margin-top: 50px !important;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;

  .boox_r {
    width: 1200px;

    .box_r_t {
      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;

      .box_r_t_l {
        padding: 0 15px;
        line-height: 45px;
        font-size: 20px;
        font-weight: bold;
        color: #444;
        border-bottom: 2px solid #9e070e;
      }

      .box_r_t_r {
        font-size: 14px;
        color: #666;

        span {
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }

    .box_r_b {
      padding: 20px 0;

      ul {
        border-bottom: 1px solid #eee;
        padding-bottom: 30px;

        li {
          margin: 0;
          padding: 0;

          div {
            width: 100%;
            height: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #444;

            &:hover {
              cursor: pointer;
              color: #9E070E;
            }

            span {
              &:nth-child(1) {
                width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 16px;
              }

              &:nth-child(2) {
                width: 20%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                text-align: right;
              }
            }
          }
        }
      }
    }
  }
}

/deep/ .el-pagination button {
  //background-color: #FFFFFF !important;
  //color: white !important;
}

/deep/ .el-pagination .el-pager li {
  border: 1px solid #ccc;
  background-color: #FFFFFF !important;
  color: #575757 !important;
}

/deep/ .el-pagination .el-pager li.active {
  background-color: #8D080E !important;
  color: white !important;
}

.bottom {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  .bottom_ {
    transform: scale(1.2);
  }
}

ul, li {
  list-style: none;
}

.content {
  width: 1200px;
  margin: 0 auto;
}
</style>




// WEBPACK FOOTER //
// src/views/search/search.vue